import { ContactModel } from "../../common/models/CommonModels";

export interface RegisterUserModel {
    company: string;
    firstName: string;
    lastName: string;
    contact: ContactModel;
    termsAccepted: boolean;
}

export const getEmptyRegisterUserModel = () => {
    return {
        company: "",
        firstName: "",
        lastName: "",
        contact: {
            email: "",
            emailDetails: "",
            phoneNumber: "",
            phoneNumberDetails: ""
        },
        termsAccepted: false
    };
}

export interface RegistrationPromptModel {
    identifier: string;
}


// WEBPACK FOOTER //
// ./src/register/user/RegisterUserModels.ts